import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { cloneDeep } from 'lodash'

import {
  getBuildingAnalyticsDataAndChart,
  setLoadingAnalyticsDataState,
  setDate,
  selectIsLoadingAnalytics,
  selectAnalyticsData,
  selectReviewsData,
  selectStartEndDates,
  getPackagesAnalytics,
  selectLoadingPackagesAnalytics,
  selectPackagesAnalytics,
} from '../../reducers/buildingAnalyticsReducer'
import { selectActiveBuilding } from '../../reducers/buildingSelectorReducer'

import BuildingAnalyticsHeader from './BuildingAnalyticsHeader'
import AnalyticsMainView from './AnalyticsMainView'

const BuildingAnalytics = () => {
  const dispatch = useDispatch()
  const loadingAnalytics = useSelector(selectIsLoadingAnalytics)
  const analyticsData = useSelector(selectAnalyticsData)
  const clonedAnalyticsData = cloneDeep(analyticsData)
  const reviewsData = useSelector(selectReviewsData)
  const selectedBuilding = useSelector(selectActiveBuilding)
  const startEndDates = useSelector(selectStartEndDates)
  const packagesAnalytics = useSelector(selectPackagesAnalytics)
  const loadingPackages = useSelector(selectLoadingPackagesAnalytics)

  const selectPeriodHandler = ({ start, end }) => dispatch(setDate(start, end))

  useEffect(() => {
    ;(async () => {
      try {
        await dispatch(setLoadingAnalyticsDataState(true))
        dispatch(getBuildingAnalyticsDataAndChart())
        if (selectedBuilding?.id) {
          dispatch(getPackagesAnalytics(selectedBuilding.id))
        }
      } catch (error) {
        console.error(error)
      }
    })()
  }, [startEndDates[0], startEndDates[1], selectedBuilding])

  return (
    <section className="ctp-building-analytics">
      <BuildingAnalyticsHeader
        selectPeriodHandler={selectPeriodHandler}
        startEndDates={startEndDates}
      />
      <AnalyticsMainView
        startEndDates={startEndDates}
        loading={loadingAnalytics}
        analyticsData={clonedAnalyticsData}
        reviewsData={reviewsData}
        packagesAnalytics={packagesAnalytics}
        loadingPackages={loadingPackages}
      />
    </section>
  )
}

BuildingAnalytics.propTypes = {
  getBuildingAnalyticsDataAndChart: PropTypes.func,
  setLoadingAnalyticsDataState: PropTypes.func,
  setDate: PropTypes.func,
  loadingAnalytics: PropTypes.bool,
  analyticsData: PropTypes.object,
  reviewsData: PropTypes.array,
  startEndDates: PropTypes.array,
  selectedBuilding: PropTypes.object,
}

export default BuildingAnalytics
